import React, { useState, useEffect } from "react";
import styled from "styled-components";
import Blank from "../../../../DefaultStyles/Blank";
import { ChatSection, ChatSectionTitle } from "./ChatSearchResult";
import RecentChatHeader from "./RecentChat/RecentChatHeader";
import LinkidChatTable from "./RecentChat/LinkidChatTable";
import FirebaseChatTable from "./RecentChat/FirebaseChatTable";

interface RecentChatProps {
  dropDownValue: {
    label?: string;
  };
  searchValue?: string;
  chatId?: string;
}

interface SMessageCheckIcon {
  isRead: number;
}

export interface IMessageData extends SMessageCheckIcon {
  id: number;
  writer: number;
  message: string;
  url?: string;
  image?: string;
  date: string;
  roomid?: number;
}

export default function RecentChat({
  dropDownValue,
  searchValue,
  chatId,
}: RecentChatProps) {
  console.log(chatId);

  console.log(searchValue);

  const [isFirebaseChat, setIsFirebaseChat] = useState(false);
  const [roomId, setRoomId] = useState(0);
  const [messageData, setMessageData] = useState<IMessageData[]>([]);

  useEffect(() => {}, [chatId]);

  return (
    <ChatSection id="recent-chat-section">
      <ChatSectionTitle>최근 대화 조회</ChatSectionTitle>

      <RecentChatHeader
        dropDownValue={dropDownValue}
        searchValue={searchValue}
        isFirebaseChat={isFirebaseChat}
        toggleButtonEvent={() => setIsFirebaseChat((prev) => !prev)}
        roomId={roomId}
        messageData={messageData}
        setMessageData={setMessageData}
      />

      <Blank blankHeight={12} />

      {isFirebaseChat ? (
        <FirebaseChatTable chatId={chatId} />
      ) : (
        <LinkidChatTable
          chatId={chatId}
          roomId={roomId}
          setRoomId={setRoomId}
          messageData={messageData}
          setMessageData={setMessageData}
        />
      )}
    </ChatSection>
  );
}

export const CalendarLine = styled.div`
  width: 12px;
  height: 1px;
  background-color: #858c97;
`;

export const HelpIcon = styled.span`
  font-size: 24px;
  color: #858c97;
`;

export const More = styled.img`
  cursor: pointer;
  position: absolute;
  left: 47%;
  margin-top: -23px;
  width: 46px;
  height: 46px;
`;
